import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { FALLBACK_CONFIG } from "@/config/site";

const ConfigContext = createContext(FALLBACK_CONFIG);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(FALLBACK_CONFIG);

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((res) => setCfg({ ...FALLBACK_CONFIG, ...res.data }))
      .catch(() => {});
  }, []);

  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
